import { IconButton, Tooltip } from "@mui/material";
import { Close } from "@mui/icons-material";

/**
 * 
 * @param {function} onBtnClick 
 * @param {string} tooltip 
 * @param {"inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning"} color 
 * @param {"small" | "medium" | "large"} size 
 */
export default function IconButtonClose({ onBtnClick, tooltip = "", color = "", size = "large" }) {
  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={onBtnClick} size={size} color={color}>
        <Close fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
}
